import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { MobileSelectionItem } from './MobileSelectionItem';
import { Colors } from '../../../../play-core/styles/Colors';
import { equals } from '../../../../play-core/utils/array-helper';
import { NoResultDropdownItem } from '../Dropdown/NoResultsDropdownItem';
import { MobileDialogButton } from '../MobileDialog/MobileDialogButton';
import { useMobileDialogDispatch } from '../MobileDialog/MobileDialogContext';
import { MobileDialogHeader } from '../MobileDialog/MobileDialogHeader';
import { SearchInput } from '../SearchInput/SearchInput';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MobileSelection = ({
  title,
  items,
  selectedItemIds,
  onChange,
  isLoading,
  saveButtonText
}) => {
  const {
    t
  } = useTranslation();
  const [selectedIds, setSelectedIds] = useState(selectedItemIds);
  const [searchTerm, setSearchTerm] = useState('');
  const mobileDialogDispatch = useMobileDialogDispatch();
  const isSearchAvailable = items.length >= 10;
  const hasChanges = !equals(selectedItemIds, selectedIds);
  const hasSelection = selectedIds.length > 0;
  const filteredItems = items.filter(item => item.title && item.title.toLowerCase().includes(searchTerm.trim().toLowerCase()));
  useEffect(() => setSelectedIds(selectedItemIds), [selectedItemIds]);
  const toggleItem = id => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(selectedItem => selectedItem !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };
  const onSave = () => hasChanges && onChange(selectedIds);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(MobileDialogHeader, {
      closeIcon: "back",
      title: title,
      actionVisible: hasSelection,
      actionText: t('global.reset'),
      isLoading: isLoading,
      onAction: () => setSelectedIds([]),
      onClose: onSave
    }), isSearchAvailable && /*#__PURE__*/_jsx(StyledSearchInput, {
      searchTerm: searchTerm,
      onSearch: value => setSearchTerm(value)
    }), /*#__PURE__*/_jsxs(List, {
      children: [filteredItems.map(item => /*#__PURE__*/_jsx(MobileSelectionItem, {
        item: item,
        isSelected: selectedIds.includes(item.id),
        onToggle: () => toggleItem(item.id),
        searchTerm: searchTerm.trim()
      }, item.id)), filteredItems.length === 0 && /*#__PURE__*/_jsx(NoResultDropdownItem, {})]
    }), /*#__PURE__*/_jsx(MobileDialogButton, {
      text: saveButtonText,
      onClick: () => {
        onSave();
        mobileDialogDispatch({
          type: 'close-all'
        });
      }
    })]
  });
};
const Container = styled.div.withConfig({
  displayName: "MobileSelection__Container",
  componentId: "sc-14xwld5-0"
})(["background-color:", ";height:100%;width:100%;display:flex;flex-direction:column;"], Colors.GREY_1a1a1a);
const List = styled.ul.withConfig({
  displayName: "MobileSelection__List",
  componentId: "sc-14xwld5-1"
})(["margin:0;padding:0;height:100%;overflow-y:auto;-webkit-overflow-scrolling:touch;"]);
export const StyledSearchInput = styled(SearchInput).withConfig({
  displayName: "MobileSelection__StyledSearchInput",
  componentId: "sc-14xwld5-2"
})(["margin:8px 16px;"]);